module.exports = __webpack_public_path__ + "img/selected6-min.70542ed5.png";